import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";

export type TscreenType = "PC" | "TABLET" | "MOBILE";

const useGetScreenType = (): TscreenType => {
  const [screenType, setScreenType] = useState<TscreenType>("PC");
  const isInPC = useMediaQuery("(min-width: 1240px)");
  const isInTablet = useMediaQuery("(min-width: 600px)");

  useEffect(() => {
    if (isInPC) {
      setScreenType("PC");
    } else if (isInTablet) {
      setScreenType("TABLET");
    } else {
      setScreenType("MOBILE");
    }
  }, [isInPC, isInTablet]);

  return screenType;
};

export default useGetScreenType;
